module.exports = __webpack_public_path__ + "img/psychological_renbao_05.b16c71a9.jpg";